var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyClipBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5H6.5C5.94772 1.5 5.5 1.94771 5.5 2.5V3C5.5 3.55228 5.94772 4 6.5 4H9.5C10.0523 4 10.5 3.55228 10.5 3V2.5C10.5 1.94771 10.0523 1.5 9.5 1.5Z",
    stroke: "black",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.5H12.25C12.5152 2.5 12.7696 2.60536 12.9571 2.79289C13.1446 2.98043 13.25 3.23478 13.25 3.5V13.5C13.25 13.7652 13.1446 14.0196 12.9571 14.2071C12.7696 14.3946 12.5152 14.5 12.25 14.5H3.75C3.48478 14.5 3.23043 14.3946 3.04289 14.2071C2.85536 14.0196 2.75 13.7652 2.75 13.5V3.5C2.75 3.23478 2.85536 2.98043 3.04289 2.79289C3.23043 2.60536 3.48478 2.5 3.75 2.5H5.25",
    stroke: "black",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyClipBoard);
export default __webpack_public_path__ + "static/media/emptyClipBoard.54563b55e18a6832c9886521207ed61b.svg";
export { ForwardRef as ReactComponent };